import * as React from 'react';
import Series from '../Series';

// This HOC returns Series component with injected type
import { jsx as _jsx } from "react/jsx-runtime";
export default function withSeriesType(seriesType, additionalProps = {}) {
  const SeriesComponent = props => /*#__PURE__*/_jsx(Series, {
    ...props,
    ...additionalProps,
    type: seriesType.toLowerCase()
  });
  SeriesComponent.displayName = `${seriesType}Series`;
  return SeriesComponent;
}